import { HttpHeaders } from '@angular/common/http';

export function getHeaders(contentType: string = 'application/json'): HttpHeaders {
  let headers = new HttpHeaders().set('Content-Type', contentType);
  if (localStorage['currentUser']) {
    const user = JSON.parse(localStorage['currentUser']);
    const token = typeof user?.token === 'string'
      ? user.token.replace(/^Bearer\s+/i, '').trim()
      : '';
    if (token) {
      headers = headers.set('Authorization', token);
    }
  }
  return headers;
}
